import { Offer } from '@wwt/entities/search-response'

import { useGetReservation } from '@/entities/reservation'
import { NO_PAYMENT } from '@/shared/config/NO_PAYMENT.ts'

export const usePay = (offer: Offer | null) => {
	const reservation = useGetReservation(offer?.IDs.wwtOfferId)

	const isDisabled =
		reservation.data === undefined ||
		reservation.data.paymentLink === NO_PAYMENT

	return {
		paymentLink: reservation.data?.paymentLink,
		isDisabled: isDisabled
	}
}
